<template>
  <ContentSection skew="none" class="bg-white mx-auto py-5 pt-12 pb-10 block">
    <div class="max-w-5xl mx-auto px-2 md:px-5">
      <h2 class="text-astralblue-700 font-medium my-2 text-3xl">Who we are</h2>
      <div class="about-points">
        <div class="item">
          <svgicon class="std-grey" name="icon-location" width="35" />
          <p class="text-xl text-grey-800">
            We are a Queensland owned and operated business established in 2013.
          </p>
        </div>
        <div class="item">
          <svgicon class="std-grey" name="icon-people" width="35" />
          <p class="text-xl text-grey-800">
            We are an organisation of highly experienced subject matter experts covering a wide
            range of IT disciplines.
          </p>
        </div>
        <div class="item">
          <svgicon class="std-grey" name="icon-team" width="35" />
          <p class="text-xl text-grey-800">
            We have a dedicated team who care about our customers and the outcomes we deliver.
          </p>
        </div>
        <div class="item">
          <svgicon class="std-grey" name="icon-roi" width="35" />
          <p class="text-xl text-grey-800">
            We focus on business problems, value proposition and return on investment when
            delivering solutions.
          </p>
        </div>
      </div>
    </div>
  </ContentSection>

  <!-- <div class="about-bg">
    <div class="outer relative sect sect--about">
      <div class="inner relative mb-0">
        <h2 id="whoweare" class="heading-two">Who we are</h2>
        <div class="about-points">
          <div class="item">
            <svgicon class="std-grey" name="icon-location" width="35" />
            <p class="copy-lg">
              We are a Queensland owned and operated business established in 2013.
            </p>
          </div>
          <div class="item">
            <svgicon class="std-grey" name="icon-people" width="35" />
            <p class="copy-lg">
              We are an organisation of highly experienced subject matter experts covering a wide
              range of IT disciplines.
            </p>
          </div>
          <div class="item">
            <svgicon class="std-grey" name="icon-team" width="35" />
            <p class="copy-lg">
              We have a dedicated team who care about our customers and the outcomes we deliver.
            </p>
          </div>
          <div class="item">
            <svgicon class="std-grey" name="icon-roi" width="35" />
            <p class="copy-lg">
              We focus on business problems, value proposition and return on investment when
              delivering solutions.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div> -->
</template>

<script>
import ContentSection from '@/components/ContentSection.vue';
import '@/components/svg';
export default {
  components: { ContentSection },
  name: 'HomeAbout'
};
</script>

<style lang="scss">
.about-points {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  align-content: center;
  margin: 0;

  div.item {
    position: relative;
    width: 100%;
    // max-width: 400px;
    padding: 0;
    margin: 10px 0;
    @include media('>700px') {
      width: 50%;
      margin: 10px 0;
    }
    img,
    svg {
      width: 30px;
      position: absolute;
      top: 5px;
      left: 0;
      right: auto;
      bottom: auto;
      @include media('>700px') {
        width: 35px;
        top: 20px;
      }
    }
    svg {
      fill: #999999;
    }
    p {
      // font-size: 14px;
      padding: 0px 0px 10px 60px;
      margin: 0;
      @include media('>700px') {
        // font-size: 18px;
        padding: 20px 60px 20px 70px;
      }
    }
  }
}
</style>
